import { render } from "./TemplateC.vue?vue&type=template&id=46f68c6c"
import script from "./TemplateC.vue?vue&type=script&lang=js"
export * from "./TemplateC.vue?vue&type=script&lang=js"
script.render = render

export default script